import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import rootReducer from "./reducers/authTokenReducer";
import { configureStore } from "@reduxjs/toolkit";
import { addToken } from "./actions/addToken";
import { setTokenListener } from "./utils/apiFetch";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";

export default configureStore({
  reducer: { rootReducer },
});


const store = configureStore({ reducer: rootReducer });

setTokenListener((token) => {
  store.dispatch(addToken(token));
});

const theme = createTheme({
  overrides: {
    MuiTimelineItem: {
      missingOppositeContent: {
        "&:before": { display: "none" }, // remove spacer
      },
    },
  },
});

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <Provider store={store}>
      <App />
    </Provider>
  </ThemeProvider>,
  document.getElementById("root")
);
